var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('c-partners-hero',{staticClass:"illustration-section-01"}),_c('c-partners-tiles',{staticClass:"illustration-section-02"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }